export default {
  filter: {
    name: 'String',
    description: 'String',
    jql: 'String',
  },
  share: {
    type: 'String',
    groupname: 'String',
  },
}
